import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";

const BreastUltraSound = ({ ismodal, setIsmodal, data }) => {
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
 const[isLoading,setIsLoading]=useState(false)
  const practiseid = window.getPracticeId();
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");
  const age = calculateAge(data?.dob);
const [providerList, setProviderList] = useState([]);
  const [formData, setFormData] = useState({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    indications: "",
    tech: "",
    height: "",
    weight: "",
    rightBreast: ["", "", "", ""],
    leftBreast: ["", "", "", ""],
    comments: "",
    signature: "",
  });

  const handleChange = (section, field, value) => {
    if (section === null && Array.isArray(formData[field])) {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };
  useEffect(() => {
    if (ismodal) getProviders();
  }, [ismodal]);
useEffect(() => {
  if (!formData.provider && providerList.length > 0) {
    const providerNames = providerList.map(x => x.providername);

    if (data?.linked_provider && providerNames.includes(data.linked_provider)) {
      handleChange(null, "provider", data.linked_provider);
    } else if (providerList.length > 0) {
      handleChange(null, "provider", providerList[0].providername);
    }
  }
}, [providerList, data]);
  const getProviders = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/providers`);
      if (response.status === 200 && Array.isArray(response.data)) {
        setProviderList(response.data);
      }
    } catch (error) {
      console.error("Error fetching providers:", error);
      setToastMessage("Failed to load providers");
      setToastSeverity("error");
      setOpenToast(true);
    }
  };
  const validateForm = () => {
    const errors = [];
    if (!formData.provider) errors.push("Provider is required.");
    if (!formData.examDate) errors.push("Exam Date is required.");
    if (!formData.indications.trim()) errors.push("Indications are required.");
    if (!formData.tech.trim()) errors.push("Tech is required.");
    if (!formData.signature.trim()) errors.push("Signature is required.");
    return errors;
  };

  const handleSave =async () => {
    const errors = validateForm();
    if (errors.length > 0) {
      setToastMessage(errors[0]);
      setToastSeverity("error");
      setOpenToast(true);
    } else {
     const selectedProvider = providerList.find(
        (p) => p.providername === formData.provider
      );

      const patientDetails = {
        patientid: data.patientid,
        appointmentid: data.appointmentid,
        firstname: data.firstname,
        lastname: data.lastname,
        providername: formData.provider,
        providerid: selectedProvider?.providerid,
        pat_name: `${data?.firstname} ${data?.lastname}`,
          pat_dob: data?.dob,
        dob: formattedDOB,
        age,
        gender: data.gender === "M" ? "Male" : "Female",
      };
      let payload={...patientDetails,...formData}
try {
    setIsLoading(true)

     const user=await api.get('/auth/me')
          const [year, month, day] = formData.examDate.split("-");
          const formattedDate = `${month}/${day}/${year}`;
      
      const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
        "Worksheet_Type": "BREAST_ULTRASOUND",
        "createdby": user?.username || '',
         "appurl": window.location.origin,
        //  "appurl": "",
        "Exam_Date": formattedDate,
        "data":payload
      });
      
      if(response.status==200){
        const pdf=await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,{
        "filename": response?.data?.filename,      
        "worksheet_type":"BREAST_ULTRASOUND",
          "appurl": window.location.origin,
                // "appurl": "",
        "exam_date": formattedDate
        })
        setToastMessage("Form Submitted Successfully");
          setToastSeverity("success");
          setOpenToast(true);
          resetForm()
       setTimeout(() => {
    
        setIsmodal(false);
      }, 1000);
      
      }else{
        setToastMessage(response.message);
          setToastSeverity("info");
          setOpenToast(true);
      }
} catch (error) {
  console.log(error)
}finally{
setIsLoading(false)
}
    }
  };
const resetForm = () => {
  setFormData({
   provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    indications: "",
    tech: "",
    height: "",
    weight: "",
    rightBreast: ["", "", "", ""],
    leftBreast: ["", "", "", ""],
    comments: "",
    signature: "",
  });
};

  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">BREAST ULTRASOUND</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">×</button>
        </div>
        <hr className="mb-4 border-gray-300" />

        {/* Patient Info */}
        <div className="flex items-center space-x-4 mb-4">
          <img
            src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
            <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
       #{data?.patientid}
            </div>
            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Date of Birth:</span> {formattedDOB}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Age:</span> {age} | <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}
            </div>
          </div>
        </div>

        {/* Provider & Date */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Providers</label>
           <select
              className="w-full border rounded px-2 py-1"
              value={formData.provider}
              onChange={(e) => handleChange(null, "provider", e.target.value)}
            >
              <option value="">Select Provider</option>
              {providerList.map((provider) => (
                <option key={provider.id} value={provider.providername}>
                  {provider.providername}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Exam Date</label>
            <input
              type="date"
              className="w-full border rounded px-2 py-1"
              value={formData.examDate}
              onChange={(e) => handleChange(null, "examDate", e.target.value)}
            />
          </div>
        </div>

        {/* Indications & Tech */}
        <div className="grid grid-cols-3 gap-4 mt-4">
          <div className="col-span-2">
            <label className="block text-sm font-medium">Indications</label>
            <input
              className="w-full border rounded px-2 py-1 mt-1"
              placeholder="Enter indications"
              value={formData.indications}
              onChange={(e) => handleChange(null, "indications", e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Tech</label>
            <input
              className="w-full border rounded px-2 py-1 mt-1"
              placeholder="Enter tech"
              value={formData.tech}
              onChange={(e) => handleChange(null, "tech", e.target.value)}
            />
          </div>
        </div>

        {/* Height & Weight */}
        <div className="grid grid-cols-2 gap-4 mt-4">
          <div>
            <label className="block text-sm font-medium">Height</label>
            <input
             type="number"
  step="0.01"
  inputMode="decimal"
              className="w-full border rounded px-2 py-1 mt-1"
              placeholder="Enter height"
              value={formData.height}
              onChange={(e) => handleChange(null, "height", e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Weight</label>
            <input
             type="number"
  step="0.01"
  inputMode="decimal"
              className="w-full border rounded px-2 py-1 mt-1"
              placeholder="Enter weight"
              value={formData.weight}
              onChange={(e) => handleChange(null, "weight", e.target.value)}
            />
          </div>
        </div>

        {/* Right & Left Breast */}
        <div className="grid grid-cols-2 gap-4 mt-4">
          <div>
            <label className="block text-sm font-medium mb-1">Right Breast</label>
            {formData.rightBreast.map((val, i) => (
              <div key={`right-${i}`} className="flex items-center mb-2">
                <span className="w-5 text-sm">{i + 1}.</span>
                <input
                 type="number"
  step="0.01"
  inputMode="decimal"
                  className="flex-1 border rounded px-2 py-1 ml-2"
                  value={val}
                  onChange={(e) => {
                    const updated = [...formData.rightBreast];
                    updated[i] = e.target.value;
                    handleChange(null, "rightBreast", updated);
                  }}
                />
              </div>
            ))}
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Left Breast</label>
            {formData.leftBreast.map((val, i) => (
              <div key={`left-${i}`} className="flex items-center mb-2">
                <span className="w-5 text-sm">{i + 1}.</span>
                <input
                 type="number"
  step="0.01"
  inputMode="decimal"
                  className="flex-1 border rounded px-2 py-1 ml-2"
                  value={val}
                  onChange={(e) => {
                    const updated = [...formData.leftBreast];
                    updated[i] = e.target.value;
                    handleChange(null, "leftBreast", updated);
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Comments */}
        <div className="mt-4">
          <label className="block text-sm font-medium">Comments</label>
          <textarea
            className="w-full border rounded px-2 py-1 mt-1"
            rows={4}
            placeholder="Enter comments here..."
            value={formData.comments}
            onChange={(e) => handleChange(null, "comments", e.target.value)}
          ></textarea>
        </div>

        {/* Signature */}
        <div className="mt-4">
          <label className="block text-sm font-medium">Signature</label>
          <input
            className="w-full border rounded px-2 py-1 mt-1"
            placeholder="Signature"
            value={formData.signature}
            onChange={(e) => handleChange(null, "signature", e.target.value)}
          />
        </div>

        {/* Save Button */}
        <div className="flex justify-end mt-6">
          <button
            onClick={handleSave}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          >
            Save
          </button>
        </div>
      </div>
<Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
</Backdrop>
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={() => setOpenToast(false)}
      />
    </div>
  );
};

export default BreastUltraSound;
